import React from "react";
import {Link} from "react-router-dom"

interface PanelMainInnerProps {
    title?: string,
    isBg?: boolean,
    isBtn?: boolean,
    btnTxt?: string,
    btnLinkProps?: object,
    isBtnAction?: boolean,
    btnActionTxt?: string,
    handlerBtnAction?: any,
    children: React.ReactNode
}

const PanelMainInner: React.FC<PanelMainInnerProps> = ({
                                                           title = null,
                                                           isBg = false,
                                                           isBtn = false,
                                                           btnTxt = null,
                                                           btnLinkProps= {},
                                                           isBtnAction = false,
                                                           btnActionTxt = null,
                                                           handlerBtnAction,
                                                           children
                                                       }) => {
    return (
        <div className="p-8">
            <div className="max-w-screen-2xl mx-auto mb-4 flex justify-between items-center">
                <div className="text-3xl font-semibold text-slate-700">{title}</div>
                <div className={"mr-4"}>
                    {isBtn &&
                        <div className={"text-primary border border-primary text-md py-2 px-2 rounded-xl cursor-pointer transition duration-200 hover:bg-primary hover:text-white"}>
                            <Link to={btnLinkProps}>{btnTxt}</Link>
                        </div>
                    }
                    {isBtnAction &&
                        <div onClick={handlerBtnAction} className={"text-primary border border-primary text-md py-2 px-2 rounded-xl cursor-pointer transition duration-200 hover:bg-primary hover:text-white"}>
                            <span>{btnActionTxt}</span>
                        </div>
                    }
                </div>
            </div>
            <div className="max-w-screen-2xl mx-auto py-4 animate-fade">
                <div className={`${isBg ? "bg-white" : null} rounded-3xl border-gray-200 min-h-full p-6`}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default PanelMainInner